import React from "react";
import { Markup } from "interweave";

const MessageAccueil = ({ website }) => {
    return (
        <div>
            {!!website.messageAccueil &&
            <div className="alert-covid"><Markup content={website.messageAccueil} /></div>
            }
        </div>
    );
};

export default MessageAccueil;
